import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ko' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg border-2 border-green-600 text-green-600 hover:bg-green-50 transition-all duration-200 font-medium text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
      aria-label={`Switch to ${i18n.language === 'en' ? 'Korean' : 'English'}`}
    >
      <motion.span
        key={i18n.language}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.2 }}
        className="text-base"
      >
        {i18n.language === 'en' ? '🇰🇷' : '🇺🇸'}
      </motion.span>
      <span className="font-semibold">
        {i18n.language === 'en' ? '한국어' : 'English'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
